import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1F8A70', // Emerald
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#0F1E2E', // Dark Navy

            contrastText: '#ffffff',
        },
        background: {
            default: '#f8fafc',
        },
    },
    shape: {
        borderRadius: 10, // Matching your nav-menu and card styles
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none', // Keeps buttons looking modern and clean
                    fontWeight: 600,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                },
            },
        },
    },
});

export default theme;